@if (imageUrl) {
  <div class="group relative">
    <img
      [alt]="header.images[0]?.alt"
      [src]="imageUrl"
      [style]="{  maxHeight: imageHeight + 'px' }"
      class="max-w-[100px] md:max-w-[150px] lg:max-w-[200px]"
      id="catalog_header_img_detail-image"
      />
      @if (showHeaderImageIcon) {
        <div
          class="hidden group-hover:flex justify-center items-center absolute top-0 right-0 bottom-0 left-0 bg-gray-300/75"
          >
          <pc-shared-nibble-type-icon size="lg" type="REC"></pc-shared-nibble-type-icon>
        </div>
      }
      <cat-multi-image-download-checkbox
        [coreId]="coreId"
        [image]="imageUrl"
        [recordId]="header.id"
        [title]="item.GulliverTabName"
        [type]="item.GulliverRecType"
        class="absolute top-2 left-2"
      ></cat-multi-image-download-checkbox>
      <cat-image-preview-button [coreId]="coreId" [item]="item" class="absolute top-2 right-2"></cat-image-preview-button>
    </div>
  }
